import { type ChapterInfo } from 'api/types/ChapterInfo';
import { type RawChapterInfo } from 'api/types/ChapterInfo/RawChapterInfo';

export const parseChapterInfo = (data: RawChapterInfo, id: string): ChapterInfo => {
  const parsedData: ChapterInfo = {
    video: data.video,
    badge: data.badge,
    state: data.state,
    region: data.region,
    regionType: data.region_type,
    chapterCategoryId: data.chapter_category_id,
    comingSoonVisible: data.coming_soon_visible,
    essentialsChapter: data.essentials_chapter,
    introChapter: Boolean(data.intro_chapter),
    alternativeTrain: Boolean(data.alternative_train),
    testChapter: Boolean(data.test_chapter),
    hiddenInSource: Boolean(data.hidden_in_source),
    specialization: Boolean(data.specialization),
    partner: Boolean(data.partner),
    tiers: [data.tier_1, data.tier_2, data.tier_3, data.tier_4],
    translationStatus: Boolean(data.translation_status),
    lastTranslatedDate: data.last_translated_date,
    id: data.chapterID,
    appId: id,
    chapterNumber: Number(data.chapterNumber),
    comingSoon: data.coming_soon_visible === true,
    upcoming: Boolean(data.upcoming),
    title: data.chapterTitle,
    image: `https://travprocdn.imgix.net/${id}/${data.chapterImage}`,
    imagePro: `https://travprocdn.imgix.net/${id}/${data.chapterImagePro}`,
    itemCount: Number(data.chapterItemCount) || 0,
    itemCountMin: Number(data.chapterItemCountMin) || 0,
  };

  Object.keys(parsedData).forEach((k) => {
    const key = k as keyof ChapterInfo;

    if (parsedData[key] === '') {
      (parsedData[key] as string | null) = null;
    }
  });

  return parsedData;
};
